module.exports = __webpack_public_path__ + "img/icon-google.30125729.png";